



















import { Component, Vue } from 'vue-property-decorator';
import { TOP_MENU } from '@/constants/top-menu.constant';

@Component
export default class AppToolbar extends Vue {
  get breadcrumbs() {
    const currentPaths = this.$route.fullPath.split('/');
    currentPaths.splice(0, 1);

    const results: {
      name: string;
      route: string;
      icon?: string;
      children?: any;
    }[] = [{ name: 'NAVIGATION.DASHBOARD', route: '/', icon: 'mdi-home' }];

    let currentContext = TOP_MENU;
    let currentPath = '';
    for (const path of currentPaths) {
      currentPath += '/' + path;
      const match = currentContext.find((i) => i.route === currentPath);
      if (match) {
        const { name, route, icon } = match as {
          name: string;
          route: string;
          icon?: string;
        };
        results.push({ name, route, icon });
        if (match.children && Array.isArray(match.children)) {
          currentContext = match.children as any[];
        }
      }
    }
    return results;
  }
}
